import { render } from "./WeatherHighlights.vue?vue&type=template&id=2aed8ce1&scoped=true"
import script from "./WeatherHighlights.vue?vue&type=script&lang=js"
export * from "./WeatherHighlights.vue?vue&type=script&lang=js"

import "./WeatherHighlights.vue?vue&type=style&index=0&id=2aed8ce1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aed8ce1"]])

export default __exports__